import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
} from "react-router-dom";

import {
  navigationService,
  NavItem,
} from "../pages/publicservice/navigationService";

// =========================================
// PROPS
// =========================================

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

// =========================================
// COMPONENT
// =========================================

const MobileMenu: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {

  // =========================================
  // STATES
  // =========================================

  const [menus, setMenus] = useState<NavItem[]>([]);

  const [loading, setLoading] = useState(false);

  // =========================================
  // LOAD MENUS
  // =========================================

  useEffect(() => {

    loadMenus();

  }, []);

  async function loadMenus() {

    try {

      setLoading(true);

      const response =
        await navigationService.getAll();

      if (response.isSuccess) {

        const activeMenus =
          (response.dataList || [])
            .filter(
              menu =>
                menu.status ===
                "Active"
            )
            .sort(
              (a, b) =>
                a.displayOrder -
                b.displayOrder
            );

        setMenus(activeMenus);
      }

    } catch (error) {

      console.error(
        "Mobile menu load failed",
        error
      );

    } finally {

      setLoading(false);
    }
  }

  // =========================================
  // UI
  // =========================================

  return (

    <div
      className={`vs-menu-wrapper ${
        isOpen
          ? "vs-body-visible"
          : ""
      }`}
    >

      <div className="vs-menu-area text-center">

        {/* =========================================
            MOBILE LOGO
        ========================================= */}

        <div className="mobile-logo">

          <Link
            to="/"
            onClick={onClose}
          >

            <img
              src="/assets/img/logo.png"
              alt="Ninesister Jewels"
              className="logo"
            />

          </Link>

          {/* CLOSE BUTTON */}

          <button
            type="button"
            className="vs-menu-toggle"
            onClick={onClose}
          >

            <i className="fal fa-times"></i>

          </button>

        </div>

        {/* =========================================
            MOBILE MENU
        ========================================= */}

        <div className="vs-mobile-menu">

          {loading ? (

            <div className="py-4">
              Loading menu...
            </div>

          ) : (

            <ul>

              {menus.map(menu => (

                <li
                  key={
                    menu.menuID ??
                    menu.menuName
                  }
                >

                  {/* MAIN MENU */}

                  <Link
                    to={menu.menuUrl}
                    target={
                      menu.targetType
                    }
                    onClick={onClose}
                  >

                    {menu.menuName}

                  </Link>

                  {/* =========================================
                      SUB MENU
                  ========================================= */}

                  {menu
                    .navigationSubMenus
                    ?.filter(
                      sub =>
                        sub.status ===
                        "Active"
                    )
                    .sort(
                      (a, b) =>
                        a.displayOrder -
                        b.displayOrder
                    )
                    .length > 0 && (

                    <ul>

                      {menu
                        .navigationSubMenus
                        .filter(
                          sub =>
                            sub.status ===
                            "Active"
                        )
                        .sort(
                          (a, b) =>
                            a.displayOrder -
                            b.displayOrder
                        )
                        .map(sub => (

                          <li
                            key={
                              sub.subMenuID ??
                              sub.subMenuName
                            }
                          >

                            <Link
                              to={
                                sub.subMenuUrl
                              }
                              target={
                                sub.targetType
                              }
                              onClick={
                                onClose
                              }
                            >

                              {
                                sub.subMenuName
                              }

                            </Link>

                          </li>

                        ))}

                    </ul>

                  )}

                </li>

              ))}

              {/* EXTRA MENU */}

              <li>

                <Link
                  to="/my-account"
                  onClick={onClose}
                >

                  My Account

                </Link>

              </li>

              <li>

                <Link
                  to="/wishlist"
                  onClick={onClose}
                >

                  Wishlist

                </Link>

              </li>

              <li>

                <Link
                  to="/cart"
                  onClick={onClose}
                >

                  Cart

                </Link>

              </li>

              <li>

                <Link
                  to="/login"
                  onClick={onClose}
                >

                  Login

                </Link>

              </li>

            </ul>

          )}

        </div>

      </div>

    </div>
  );
};

export default MobileMenu;